import { render, staticRenderFns } from "./add-edit-panel.vue?vue&type=template&id=1ca064ec&"
import script from "./add-edit-panel.vue?vue&type=script&lang=js&"
export * from "./add-edit-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports